/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - subscription-invoice.njk
 *   - subscription-invoice.css
 */

export const SUBSCRIPTION_INVOICE_TEMPLATE = `<div class="a4-container">
  <!-- Header Row (50/50 Split) -->
  <div class="a4-hdr-row">
    <div class="a4-hdr-left">
      {% if logoUrl %}
        <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ providerName }}"/>
      {% else %}
        <!-- Professional Text-based branding if logo is missing -->
        <div style="font-size: 1.8em; font-weight: 800; letter-spacing: -1px; color: #111827;">{{ providerName }}</div>
      {% endif %}
    </div>
    <div class="a4-hdr-right-store">
      <div class="store-title" style="font-size: 1.2em; font-weight: 700; color: #111827;">{{ providerName }}</div>
      {% if providerAddress %}<p style="color: #4b5563;">{{ providerAddress }}</p>{% endif %}
      {% if providerPhone %}<p style="color: #4b5563;">Tel: {{ providerPhone }}</p>{% endif %}
      {% if providerEmail %}<p style="color: #4b5563;">{{ providerEmail }}</p>{% endif %}
    </div>
  </div>

  <!-- Horizontal Metadata Row -->
  <div class="a4-meta-row">
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Invoice No</span>
      <strong class="a4-meta-val">{{ invoiceNo }}</strong>
    </div>
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Issue Date</span>
      <strong class="a4-meta-val">{{ issuedDate }}</strong>
    </div>
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Due Date</span>
      <strong class="a4-meta-val">{{ dueDate }}</strong>
    </div>
    <div class="a4-meta-col text-right">
      <span class="a4-meta-lbl">Status</span>
      <span class="status-badge-a4 paid">PAID</span>
    </div>
  </div>

  <!-- Customer / Billed To Section -->
  <div class="a4-cust-card" style="margin-bottom: 15px;">
    <div class="a4-cust-grid">
      <span class="a4-cust-lbl">Billed To Name:</span>
      <span class="a4-cust-val">{{ tenantName }}</span>
      
      {% if tenantSubName %}
        <span class="a4-cust-lbl">Sub Account:</span>
        <span class="a4-cust-val" style="text-transform: none; font-weight: normal;">{{ tenantSubName }}</span>
      {% endif %}

      {% if tenantEmail %}
        <span class="a4-cust-lbl">Email Address:</span>
        <span class="a4-cust-val" style="text-transform: none; font-weight: normal;">{{ tenantEmail }}</span>
      {% endif %}

      {% if tenantPhone %}
        <span class="a4-cust-lbl">Contact Number:</span>
        <span class="a4-cust-val" style="font-weight: normal;">{{ tenantPhone }}</span>
      {% endif %}

      <span class="a4-cust-lbl">Payment Reference:</span>
      <span class="a4-cust-val" style="text-transform: none;">{{ reference }}</span>
    </div>
  </div>

  <!-- Items Table -->
  <table class="a4-items-table">
    <thead>
      <tr>
        <th class="a4-col-no">NO</th>
        <th class="a4-col-desc">ITEM DESCRIPTION</th>
        <th class="a4-col-qty">BILLING PERIOD</th>
        <th class="a4-col-amount">AMOUNT</th>
      </tr>
    </thead>
    <tbody>
      <tr class="a4-item-row">
        <td class="a4-col-no">1</td>
        <td class="a4-desc-cell">
          <strong>{{ packageName }} — Monthly Subscription Plan</strong>
          <br/>
          <span style="color: #6b7280; font-size: 0.85em;">Subscription package base charge for POS system access</span>
        </td>
        <td class="a4-qty-cell" style="font-size: 0.9em; white-space: nowrap;">{{ billingPeriod }}</td>
        <td class="a4-amount-cell">{{ baseAmount | formatPrice }}</td>
      </tr>
      {% if additionalAmount > 0 %}
        <tr class="a4-item-row">
          <td class="a4-col-no">2</td>
          <td class="a4-desc-cell">
            <strong>Additional Workspace Features (Add-ons)</strong>
            <br/>
            <span style="color: #6b7280; font-size: 0.85em;">Charges for extra active modules during the billing cycle</span>
          </td>
          <td class="a4-qty-cell" style="font-size: 0.9em; white-space: nowrap;">{{ billingPeriod }}</td>
          <td class="a4-amount-cell">{{ additionalAmount | formatPrice }}</td>
        </tr>
      {% endif %}
    </tbody>
  </table>

  <!-- Modern Summary Section -->
  <div class="a4-summary-container">
    <div class="a4-summary-left-card">
      <div class="a4-info-row">
        <span class="a4-info-label">Payment Mode</span>
        <span class="a4-info-value payment-badge">{{ paymentMethod }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Billing Period</span>
        <span class="a4-info-value" style="font-size: 0.85em;">{{ billingPeriod }}</span>
      </div>
      {% if paidAt %}
        <div class="a4-info-row">
          <span class="a4-info-label">Payment Date</span>
          <span class="a4-info-value" style="font-size: 0.85em;">{{ paidAt }}</span>
        </div>
      {% endif %}
    </div>

    <div class="a4-summary-right-totals">
      <div class="a4-total-row">
        <span class="a4-total-lbl">Sub Total</span>
        <span class="a4-total-val">{{ baseAmount | formatPrice }}</span>
      </div>
      {% if additionalAmount > 0 %}
        <div class="a4-total-row">
          <span class="a4-total-lbl">Add-on Modules</span>
          <span class="a4-total-val">{{ additionalAmount | formatPrice }}</span>
        </div>
      {% endif %}
      <div class="a4-grand-total-row">
        <span class="a4-grand-lbl">GRAND TOTAL</span>
        <span class="a4-grand-val">{{ currency }} {{ totalAmount | formatPrice }}</span>
      </div>
    </div>
  </div>

  {% if note %}
    <div style="margin: 12px 0; background: #f9fafb; border: 1px solid #e5e7eb; border-left: 4px solid #374151; padding: 8px 12px; font-size: 12px; color: #374151; line-height: 1.4;">
      <strong style="font-size: 9px; letter-spacing: 0.5px; text-transform: uppercase; display: block; margin-bottom: 2px;">Notes / Instructions</strong>
      {{ note }}
    </div>
  {% endif %}

  <!-- Signature Section -->
  <div class="a4-signature-section" style="margin-top: 40px;">
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Customer Signature</div>
    </div>
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Authorized Signature</div>
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="a4-ftr" style="margin-top: 25px; border-top: 1px dashed #e5e7eb; padding-top: 10px;">
    <div class="a4-ftr-thank" style="font-size: 1em; color: #111827;">Thank you for your business!</div>
    <div class="a4-ftr-powered" style="margin-top: 4px; font-size: 0.8em; color: #6b7280;">Powered by {{ webName }}</div>
  </div>
</div>
`;

export const SUBSCRIPTION_INVOICE_CSS = `@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--pi-font, 12px);
  color: #000;
  background: #fff;
  padding: 0;
  line-height: 1.35;
}

.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  background: #fff;
  width: 100%;
  padding: 0px 4px;
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 70px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.4em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.a4-hdr-right-store p {
  font-size: 0.85em;
  margin: 1px 0;
  color: #4b5563;
}

.a4-sec-title {
  font-size: 1.05em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 4px;
  color: #212529;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 6px 8px;
  margin-bottom: 15px;
  background-color: #f8f9fa;
  font-size: 0.85em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 1px;
  max-width: 35%;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.9em;
  color: #111827;
  font-weight: 700;
  word-break: break-all;
}

.a4-cust-card {
  margin: 8px 0 15px 0;
  font-size: 0.9em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 3px 8px;
}

.a4-cust-lbl {
  font-weight: 600;
  color: #4b5563;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
  color: #111827;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  font-size: 0.9em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #9ca3af;
  padding: 6px 8px;
}

.a4-items-table th {
  background-color: #f3f4f6;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85em;
}

.a4-col-no {
  width: 5%;
  text-align: center;
}
.a4-col-desc {
  width: 52%;
  text-align: left;
}
.a4-col-qty {
  width: 28%;
  text-align: center;
}
.a4-col-amount {
  width: 15%;
  text-align: right;
}

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-qty-cell {
  text-align: center;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 600;
}

/* ── Modern Summary Section ── */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 15px;
  gap: 20px;
}

.a4-summary-left-card {
  width: 45%;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  padding: 10px 12px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 6px;
  margin-bottom: 6px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #4b5563;
  font-weight: 500;
  font-size: 0.85em;
}

.a4-info-value {
  font-weight: 700;
  color: #111827;
  font-size: 0.85em;
}

.payment-badge {
  text-transform: uppercase;
  background-color: #f3f4f6;
  padding: 1px 6px;
  border-radius: 4px;
}

.status-badge-a4 {
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.8em;
  text-transform: uppercase;
}

.status-badge-a4.paid {
  background-color: #d1fae5;
  color: #065f46;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.9em;
  color: #4b5563;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 1.5px solid #111827;
  padding-top: 8px;
  margin-top: 4px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.1em;
  color: #111827;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.1em;
  color: #111827;
}

.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 15px;
  padding: 0 10px;
}

.a4-sig-block {
  width: 200px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #374151;
  margin-bottom: 5px;
}

.a4-sig-label {
  font-size: 0.8em;
  font-weight: 600;
  color: #4b5563;
}

.a4-ftr {
  text-align: center;
  margin-top: 20px;
  font-size: 0.85em;
  line-height: 1.4;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1em;
}

.a4-ftr-powered {
  margin-top: 4px;
  font-size: 0.75em;
  color: #9ca3af;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .a4-container {
    box-shadow: none;
    border: none;
    border-radius: 0;
    width: 100% !important;
    padding: 0;
  }
  @page {
    size: A4;
    margin: 8mm;
  }
}
`;
